import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";

import { useTheme, withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const ClubAvatar = React.forwardRef((props, ref) => {

    const { club, size, height, width } = props

    const theme = useTheme();
    const [ fontSize, setFontSize ] = useState('3.4rem');

    useEffect(() => {
        if (size) {
            switch (size) {
                case 'xs':
                    setFontSize('1.4rem');
                    break;
                case 'sm':
                    setFontSize('1.9rem');
                    break;
                case 'md':
                default: setFontSize('3.4rem')
            }
        }
    }, []);

    const StyledAvatar = withStyles({
        root: {
            width: width ?? '100%',
            height: height ?? 'auto',
            maxWidth: '300px',
            //maxHeight: '300px',
            fontSize: fontSize,
            margin: '0 auto'
        },
        colorDefault: {
            backgroundColor: club.branding.primary_color,
            color: theme.palette.getContrastText(club.branding.primary_color),
            padding: '20%'
        },
        img: {
            objectFit: 'contain'
        }
    })(Avatar);

    return (
        <StyledAvatar
            ref={ref}
            variant="rounded"
            src={club.branding.logo ? club.branding.logo.full_url : null}
            alt={club.name}
            >
            {club.branding.acronym}
        </StyledAvatar>
    )

});

ClubAvatar.propTypes = {
    club: PropTypes.object.isRequired,
};

export default ClubAvatar;
